export default __webpack_public_path__ + "static/media/Neo.a3be3a01.svg";